// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__9gcxb","paramInput":"JobSimulator_paramInput__1zPqU","input":"JobSimulator_input__1YK3Q"};